import { CommunitySubscriptionInfo } from 'types';

type SubscriptionUsageSource = {
  info?: CommunitySubscriptionInfo | null;
} | null;

export const getUsedMembersCount = (
  subscription?: SubscriptionUsageSource,
): number => Number(subscription?.info?.users ?? 0);

type MatrixCommunity = {
  users?: Array<{ id?: string | null }> | null;
};

export const isUserInCommunityMatrix = (
  matrix: MatrixCommunity[] | null | undefined,
  userId: string,
): boolean =>
  Boolean(
    matrix?.some((community) =>
      community.users?.some((user) => user?.id === userId),
    ),
  );
